t = require('views/internal/teacup-with-helpers')('board_menu_subscribed_state')

# EXPERIMENT: subscribeToWatchOrFollow
module.exports = ->
  t.check t.mustacheVar('subscribed'), t.mustacheVar('subscribeString')



// WEBPACK FOOTER //
// ./app/scripts/views/templates/board_menu_subscribed_state.coffee